/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTicketCategoryDto } from '../models/work-create-ticket-category-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkTicketCategory } from '../models/work-ticket-category';
import { WorkUpdateTicketCategoryDto } from '../models/work-update-ticket-category-dto';

@Injectable({ providedIn: 'root' })
export class WorkTicketCategoriesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ticketCategoriesV2ControllerFindAll()` */
  static readonly TicketCategoriesV2ControllerFindAllPath = '/v2/ticket-categories';

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketCategoriesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketCategoriesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTicketCategory>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketCategoriesV2Service.TicketCategoriesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTicketCategory>>;
      })
    );
  }

  /**
   * Required permissions: tickets:admin, tickets:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketCategoriesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketCategoriesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTicketCategory>> {
    return this.ticketCategoriesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTicketCategory>>): Array<WorkTicketCategory> => r.body)
    );
  }

  /** Path part for operation `ticketCategoriesV2ControllerCreate()` */
  static readonly TicketCategoriesV2ControllerCreatePath = '/v2/ticket-categories';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketCategoriesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketCategoriesV2ControllerCreate$Response(
    params: {
      body: WorkCreateTicketCategoryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicketCategory>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketCategoriesV2Service.TicketCategoriesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicketCategory>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketCategoriesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketCategoriesV2ControllerCreate(
    params: {
      body: WorkCreateTicketCategoryDto
    },
    context?: HttpContext
  ): Observable<WorkTicketCategory> {
    return this.ticketCategoriesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicketCategory>): WorkTicketCategory => r.body)
    );
  }

  /** Path part for operation `ticketCategoriesV2ControllerDelete()` */
  static readonly TicketCategoriesV2ControllerDeletePath = '/v2/ticket-categories/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketCategoriesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketCategoriesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketCategoriesV2Service.TicketCategoriesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketCategoriesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketCategoriesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.ticketCategoriesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `ticketCategoriesV2ControllerUpdate()` */
  static readonly TicketCategoriesV2ControllerUpdatePath = '/v2/ticket-categories/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketCategoriesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketCategoriesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTicketCategoryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTicketCategory>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTicketCategoriesV2Service.TicketCategoriesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTicketCategory>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketCategoriesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketCategoriesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTicketCategoryDto
    },
    context?: HttpContext
  ): Observable<WorkTicketCategory> {
    return this.ticketCategoriesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTicketCategory>): WorkTicketCategory => r.body)
    );
  }

}
